import { render, staticRenderFns } from "./MoneyField.vue?vue&type=template&id=a566f926&scoped=true&"
import script from "./MoneyField.vue?vue&type=script&lang=js&"
export * from "./MoneyField.vue?vue&type=script&lang=js&"
import style0 from "./MoneyField.vue?vue&type=style&index=0&id=a566f926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566f926",
  null
  
)

export default component.exports